import { Component, OnInit, Input, HostListener, OnChanges, SimpleChanges } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { TranslateService } from '@ngx-translate/core';
import { CurrencyService } from 'src/app/services/currency.service';
import { HttpAlertService } from 'src/app/services/http-alert.service';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { BrowserStorageService } from 'src/app/services/storage.service';
import { CartService } from 'src/app/services/cart.service';
import { Currency } from 'src/app/intefaces/currency.interface';
import { CategoryService } from 'src/app/services/category.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit, OnChanges {
  @Input() isLogin: boolean;
  userMenu: any[];
  langs: MenuItem[];
  currencies: MenuItem[];
  selectedLang: string;
  selectedCurrency: string;
  showHeaderShadow: boolean = false;
  narrowWidthMenu: MenuItem[];
  displayLanguageDialog = false;
  displayCurrencyDialog = false;
  counterCart: number = 0;
  categoriesItems: any[];

  constructor(
    private authService: AuthorizationService,
    private translate: TranslateService,
    private currencyService: CurrencyService,
    private httpAlertService: HttpAlertService,
    private router: Router,
    private userService: UserService,
    private browserStorageService: BrowserStorageService,
    private cartService: CartService,
    private categoryService: CategoryService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isLogin'].previousValue != changes['isLogin'].currentValue) {
      this.initDropdownMenu();
    }
  }

  ngOnInit(): void {
    this.initLangs();
    this.initCurrencies();
    this.initCounterItems();
    this.initDropdownMenu();

    this.categoryService.getCategories().subscribe((catResp) => {
      this.categoriesItems = catResp.data;
    });
  }

  public handlecategoryItemClick(item) {
    this.router.navigate(['/szukaj'], { queryParams: { category: item.id } });
  }

  private initCounterItems(): void {
    this.cartService.getAsyncCountItemsInCart().subscribe(data => {
      this.counterCart = data.count;
    });
  }

  public logout(): void {
    this.authService.logout();
    this.httpAlertService.success("system_logout");
    this.router.navigate(['/']);
  }

  private goToAdminPanel(): void {
    this.userService.isAdmin().subscribe(
      data => {
        if (data.data == true) {
          this.router.navigate(["/administrator-panel/orders-management"]);
        } else {
          this.router.navigate(["/"]);
        }
      }
    );
  }

  public loginDisplay = null;
  private initDropdownMenu(): void {
    this.translate.get(['main_page', 'about_us', 'contact', 'language', 'currency', 'my_orders', 'prepaid_account', 'my_details', 'logout', 'admin_panel', 'register', 'login', 'arranger_panel']).subscribe(t => {
      this.narrowWidthMenu = [
        { label: t.main_page, command: () => { this.router.navigate(["/"]); }, routerLink: '/' },
        { label: t.about_us, command: () => { this.router.navigate(["/onas"]); }, routerLink: '/onas' },
        { label: t.contact, command: () => { this.router.navigate(["/kontakt"]); }, routerLink: '/kontakt' },
        { label: t.language, command: () => { this.displayLanguageDialog = true; } },
        { label: t.currency, command: () => { this.displayCurrencyDialog = true } },
      ];
      if (this.isLogin) {
        this.userMenu = [
          { label: t.my_orders, command: () => { this.router.navigate(["/my-account/my-orders"]); }, routerLink: '/my-account/my-orders' },
          { label: t.prepaid_account, command: () => { this.router.navigate(["/my-account/prepaid-account"]); }, routerLink: '/my-account/prepaid-account' },
          { label: t.my_details, command: () => { this.router.navigate(["/my-account/my-details"]); }, routerLink: '/my-account/my-details' },
          { label: t.logout, command: () => { this.logout(); } }
        ];
        if ('admin' == this.browserStorageService.get('_role')) {
          this.userMenu.splice(0, 3, { label: t.admin_panel, command: () => { this.goToAdminPanel(); }, routerLink: '/administrator-panel/orders-management' });
        }
        if ('arranger' == this.browserStorageService.get('_role')) {
          this.userMenu.splice(0, 0, { label: t.arranger_panel, command: () => { this.router.navigate(["/my-account/note-list"]) }, routerLink: '/my-account/note-list' });
        }
        this.loginDisplay = this.browserStorageService.get("_login");
      } else {
        this.userMenu = [
          { label: t.register, command: () => { this.router.navigate(["/register"]); }, routerLink: '/register' },
          { label: t.login, command: () => { this.router.navigate(["/login"]); }, routerLink: '/login' }
        ];
      }
    });
  }

  public switchLang(lang: string): void {
    this.selectedLang = lang;
    this.translate.use(this.selectedLang);
    this.browserStorageService.set('_lang', this.selectedLang);
    this.initDropdownMenu();
  }

  public switchCurrency(currency: string): void {
    this.selectedCurrency = currency;
    this.browserStorageService.set('_currency', this.selectedCurrency);
    this.currencyService.onCurrencyEventEmitterClick();
  }

  private initCurrencies(): void {
    this.currencies = [
      { label: "PLN", command: () => { this.switchCurrency("PLN") } },
      { label: "EUR", command: () => { this.switchCurrency("EUR") } },
      { label: "USD", command: () => { this.switchCurrency("USD") } },
      { label: "GBP", command: () => { this.switchCurrency("GBP") } }
    ];

    const initCurrency = this.browserStorageService.get("_currency") != null ? this.browserStorageService.get("_currency") : "PLN";
    this.switchCurrency(initCurrency);

    this.currencyService.getCurrencies().subscribe(reponse => {
      const currencies: Currency[] = reponse.data.currencies;
      currencies.forEach((currency: Currency) => {
        this.browserStorageService.set('_' + currency.currency_code, String(currency.exchange_rate));
      });
    }); 

  }

  private initLangs(): void {

    this.langs = [
      { label: "PL", command: () => { this.switchLang("pl") } },
      { label: "EN", command: () => { this.switchLang("en") } },
      { label: "DE", command: () => { this.switchLang("de") } }
    ];

    let initLang = (this.browserStorageService.get("_lang") != null) ? this.browserStorageService.get("_lang") : 'pl';
    this.switchLang(initLang);

  }

  @HostListener("window:scroll", []) onWindowScroll() {
    const verticalOffset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    document.getElementById('back-to-top-button').style.opacity = verticalOffset > 50 ? "1" : "0";
    this.showHeaderShadow = verticalOffset > 10;
  }

  public onScrollToTop(): void {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
